define('common/views/trial_view',['require','exports','module','base/view','./trial_expiration_popup','env','services/auth/trial','services/auth/info','i18n','ldsh!../templates/trial'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    TrialExpirationPopup = require('./trial_expiration_popup'),
    config = require('env'),
    AuthTrial = require('services/auth/trial'),
    authTrial = new AuthTrial(),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    i18n = require('i18n');

  module.exports = View.extend({
    template: require('ldsh!../templates/trial'),
    className: 'ed-expire',
    helpers: function () {
      return {
        paymentsUrl: config.paymentsUrl,
        trialWarning: i18n.t('trial.warning'),
        companyId: authInfo.getCompanyId(),
      };
    },
    initialize: function () {
      if (!authTrial.hasBeenDisplayed()) this.showPopup();
    },
    onRender: function () {
      this.$el.i18n();
    },
    showPopup: function () {
      TrialExpirationPopup.show();
    },
  });
});

